import * as React from 'react';
import './_CardCreated.scss';
import { CLASS_MY_WORK_CARD } from '../../../constants';
import { Tooltip } from 'kui';
import { ICardCreatedProps } from './types';
import { getFormattedDate } from '../../../helpers/getFormattedDate';
import { AnalyzeRender } from '../../../../../helpers/memoizeHelper';
// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`myWork CardCreated`) : null;

export function CardCreated ({
    card,
    isUserTimeFormat12
}: ICardCreatedProps) {
    if (analyzeRender) analyzeRender.call(card.cardId);
    const cardAssignDate = card.cardCreated;
    const className = CLASS_MY_WORK_CARD + '__created';

    return (
        <div className={className}>
            {
                !!cardAssignDate &&
                <Tooltip
                    delayClose={1}
                    value={getFormattedDate(cardAssignDate, false, isUserTimeFormat12)}
                    isNoEvents
                >
                    <span>{getFormattedDate(cardAssignDate)}</span>
                </Tooltip>
            }
        </div>
    );
};
